import { Dropdown, FormLayout, TextInput } from 'components/common'
import SwitchField from 'components/bundleProduct/switchField'
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form'
import { ftpProfileFormFields, protocolOptions } from './utils'

interface FtpProfileDetailsFormProps {
  register: UseFormRegister<any>
  errors: FieldErrors<any>
  setValue: UseFormSetValue<any>
  control: Control<any>
  ftpProfile?: any
  isOptional?: boolean
}

const {
  FTP_PROFILE_NAME,
  FTP_PROFILE_PROTOCOL,
  FTP_PROFILE_HOST,
  FTP_PROFILE_PORT,
  FTP_PROFILE_USERNAME,
  FTP_PROFILE_PASSWORD,
  FTP_PROFILE_DIRECTORY,
  FTP_PROFILE_IS_ENABLE,
} = ftpProfileFormFields

const FtpProfileDetailsForm = ({
  register,
  errors,
  setValue,
  control,
  ftpProfile,
  isOptional = false,
}: FtpProfileDetailsFormProps) => {
  return (
    <>
      <h3 className="title">FTP Profile Details</h3>

      <FormLayout>
        {/* Top Section: Toggle */}
        <SwitchField
          control={control}
          name={FTP_PROFILE_IS_ENABLE.key}
          label={FTP_PROFILE_IS_ENABLE.label}
          description="Only enabled profiles are used to route FTP file generation."
          defaultValue={ftpProfile?.[FTP_PROFILE_IS_ENABLE.key] ?? false}
        />

        {/* Divider */}
        <div className="mb-5 border-t" />

        <div className="grid gap-x-5 gap-y-3 md:grid-cols-2 lg:grid-cols-3">
          <TextInput
            required={!isOptional}
            label={FTP_PROFILE_NAME.label}
            placeholder="e.g. Talabat - Group A"
            register={register}
            name={FTP_PROFILE_NAME.key}
            error={errors?.[FTP_PROFILE_NAME.key]?.message as string}
          />

          <Dropdown
            required={!isOptional}
            label={FTP_PROFILE_PROTOCOL.label}
            defaultValue={ftpProfile?.[FTP_PROFILE_PROTOCOL.key] ?? 'SFTP'}
            setValue={setValue}
            options={protocolOptions}
            name={FTP_PROFILE_PROTOCOL.key}
            error={errors?.[FTP_PROFILE_PROTOCOL.key]?.message as string}
          />

          <TextInput
            required={!isOptional}
            label={FTP_PROFILE_HOST.label}
            register={register}
            name={FTP_PROFILE_HOST.key}
            error={errors?.[FTP_PROFILE_HOST.key]?.message as string}
            autoComplete="off"
          />

          <TextInput
            label={FTP_PROFILE_PORT.label}
            type="number"
            register={register}
            name={FTP_PROFILE_PORT.key}
            error={errors?.[FTP_PROFILE_PORT.key]?.message as string}
            autoComplete="off"
          />

          <TextInput
            label={FTP_PROFILE_USERNAME.label}
            register={register}
            name={FTP_PROFILE_USERNAME.key}
            error={errors?.[FTP_PROFILE_USERNAME.key]?.message as string}
            autoComplete="off"
          />

          <TextInput
            label={FTP_PROFILE_PASSWORD.label}
            type="password"
            register={register}
            name={FTP_PROFILE_PASSWORD.key}
            error={errors?.[FTP_PROFILE_PASSWORD.key]?.message as string}
            autoComplete="new-password"
          />

          <TextInput
            label={FTP_PROFILE_DIRECTORY.label}
            placeholder="/"
            register={register}
            name={FTP_PROFILE_DIRECTORY.key}
            error={errors?.[FTP_PROFILE_DIRECTORY.key]?.message as string}
          />
        </div>
      </FormLayout>
    </>
  )
}

export default FtpProfileDetailsForm
